module.exports = __webpack_public_path__ + "chefy-repose.png?4639578aef4275b166ab57c33faa84ed";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chefy-repose.png
// module id = 39
// module chunks = 0